document.querySelectorAll(".checkbox-option").forEach((checkboxOption) => {
  checkboxOption.addEventListener("click", function () {
    // Identify the checkbox "box"
    const box = this.querySelector(".checkbox-custom");
    if (!box) return;

    // Remove any existing ripple
    const oldRipple = this.querySelector(".ripple");
    if (oldRipple) {
      oldRipple.remove();
    }

    // Get bounding rects
    const labelRect = this.getBoundingClientRect();
    const boxRect = box.getBoundingClientRect();

    // Compute the box's diameter
    const boxDiameter = Math.max(boxRect.width, boxRect.height);
    // 1.5x so it expands slightly outside
    const size = boxDiameter * 1.5;

    // Find box center relative to the label
    const boxCenterX = boxRect.left - labelRect.left + boxRect.width / 2;
    const boxCenterY = boxRect.top - labelRect.top + boxRect.height / 2;

    // Position the ripple so it's centered on the checkbox
    const x = boxCenterX - size / 2;
    const y = boxCenterY - size / 2;

    // Create the ripple
    const ripple = document.createElement("span");
    ripple.classList.add("ripple");
    ripple.style.width = ripple.style.height = size + "px";
    ripple.style.left = x + "px";
    ripple.style.top = y + "px";

    // Append it to the label, so it can expand beyond the .checkbox-custom
    this.appendChild(ripple);
  });
});
